export default "__VITE_ASSET__CYJWXHLD__"